import React, {useEffect} from "react";
import { FormattedMessage, useIntl } from "react-intl";
import moment from "moment";
import { VaporDatePicker, VaporAccordion } from "../../../vapor";
import { Radio, Select, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Toggle } from "@ts-digital/vrc";
import { getDepreciationAssetRates } from "../../../../store/actions/precog/assets";
import { useDispatch, useSelector } from "react-redux";
import numeral from "numeral";
import NumberFormat from "react-number-format";

const taxReliefOptions = [
  {
    id: "_2016_BALANCE_LAW",
    value: "2016_BALANCE_LAW"
  },
  {
    id: "_2017_BALANCE_LAW",
    value: "2017_BALANCE_LAW"
  },
  {
    id: "_2018_BALANCE_LAW",
    value: "2018_BALANCE_LAW"
  },
  {
    id: "_2019_BALANCE_LAW",
    value: "2019_BALANCE_LAW"
  },
  {
    id: "_2019_GROWTH_DECREE",
    value: "2019_GROWTH_DECREE"
  },
  {
    id: "_2020_BALANCE_LAW",
    value: "2020_BALANCE_LAW"
  }
];

const taxReliefTypeOptions= [
  {
    id: "BASE",
    value: "BASE",
    condition: "taxRelief",
    conditionValues: ["2016_BALANCE_LAW", "2017_BALANCE_LAW", "2018_BALANCE_LAW", "2019_GROWTH_DECREE", "2020_BALANCE_LAW"]
  },
  {
    id: "BASE4",
    value: "BASE4",
    condition: "taxRelief",
    conditionValues: ["2017_BALANCE_LAW", "2018_BALANCE_LAW", "2019_BALANCE_LAW", "2020_BALANCE_LAW"]
  },
  {
    id: "SW4",
    value: "SW4",
    condition: "taxRelief",
    conditionValues: ["2018_BALANCE_LAW", "2019_BALANCE_LAW", "2020_BALANCE_LAW"]
  }
];

/**
 * Fields for asset assignment and revocation in drawer footer
 * This is an array components
 * @returns
 */
const DepreciationDrawerFields = ({ editable, setEditable, setModifiedFields, modifiedFields, readOnly=false, setFieldsToDelete}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const depreciationAssetRates = useSelector(state => state.precog?.depreciationAssetRates?.data);
  const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY", "DDMMYYYY", "DDMMYY"];
  
  useEffect(() => {
    if (editable.subKind){
      dispatch(getDepreciationAssetRates(
        editable.group, editable.kind, editable.subKind
      ));
    }
  }, [dispatch, editable.group, editable.kind, editable.subKind]);

  useEffect(()=> {
    if (depreciationAssetRates?.ordinary !==  editable["taxDepreciationRate"] && editable["taxDepreciationRateType"] !== "MANUAL") {
      setEditable({ ...editable, taxDepreciationRateType: editable["taxDepreciationRateType"] ? editable["taxDepreciationRateType"] : "ORDINARY",  taxDepreciationRate: depreciationAssetRates?.ordinary});
      setModifiedFields({ ...modifiedFields, taxDepreciationRateType: editable["taxDepreciationRateType"] ? editable["taxDepreciationRateType"] : "ORDINARY", taxDepreciationRate: depreciationAssetRates?.ordinary });
    }
  }, [depreciationAssetRates]);
    
  return (
    <div data-testid="DepreciationDrawerFields" className="pre-cog-assets-drawer-section" style={{flexDirection: "column", gap: 0}}>
      <VaporAccordion 
        title={<FormattedMessage id={"preCog.assetsTab.drawer.taxAmortization"} />}
        autoOpenInit={true}
        autoOpen={true}
      >
        <div style={{display: "flex"}}>
          <div>
            <Radio.Group
              value={editable["taxDepreciationRateType"] || "ORDINARY"}
              onChange={e => {
                setEditable({ ...editable, "taxDepreciationRateType": e.target.value, taxDepreciationRate: depreciationAssetRates?.ordinary});
                setModifiedFields({ ...modifiedFields, "taxDepreciationRateType": e.target.value, taxDepreciationRate: depreciationAssetRates?.ordinary });
              }}
            >
              {/* {["ORDINARY","MANUAL", "DYNAMIC"].map((el, index) =>
                <Radio key={index} className="pre-cog-assets-radio" style={{ display: "flex", height: 40, alignItems: "center", marginBottom: 16 }} value={el}>
                  <FormattedMessage id={`preCog.assetsTab.drawer.${el}`}  values={{percentage: el === "ORDINARY" && depreciationAssetRates?.ordinary ? `${numeral(depreciationAssetRates?.ordinary).format("0,0.[00]")}%` : ""}} />
                  {el === "DYNAMIC" && <FontAwesomeIcon
                    icon={["fas", "info-circle"]}
                    style={{
                      color: "#0090d1",
                      cursor: "pointer",
                      fontSize: "15px",
                      marginLeft: "20px"
                    }}
                  />}
                </Radio>)} */}
              {["ORDINARY","MANUAL"].map((el, index) =>
                <Radio key={index} className="pre-cog-assets-radio" style={{ display: "flex", height: 40, alignItems: "center", marginBottom: 16 }} value={el}>
                  <FormattedMessage id={`preCog.assetsTab.drawer.${el}`}  values={{percentage: el === "ORDINARY" && depreciationAssetRates?.ordinary ? `${numeral(depreciationAssetRates?.ordinary).format("0,0.[00]")}%` : ""}} />
                </Radio>)}
            </Radio.Group>
          </div>
          <div style={{visibility: editable["taxDepreciationRateType"] === "MANUAL" ? "visible": "hidden", marginTop: "55px"}}>
            <NumberFormat
              displayType={"number"}
              allowEmptyFormatting={false}
              allowLeadingZeros={true}
              thousandSeparator={"."}
              decimalSeparator={","}              
              className="inputCustom drawer-inputCustom "
              placeholder="-"
              suffix={"%"}
              // value={editable["taxDepreciationRate"]}  
              isNumericString={editable["taxDepreciationRate"] ? true : false}
              value={editable["taxDepreciationRate"] ?  numeral(parseFloat(editable["taxDepreciationRate"])).format("0,0.00") : null}                   
              onValueChange={(el) => {                
                setEditable({ ...editable, taxDepreciationRate: el.floatValue > 100 ? 100 : el.floatValue });                
              }                
              }  
              onBlur={() => {
                if (editable.taxDepreciationRate) {
                  setModifiedFields({ ...modifiedFields, taxDepreciationRate: editable.taxDepreciationRate});
                } else {
                  setFieldsToDelete(["taxDepreciationRate"]);
                }
              }}                                  
            />
            
          </div>
        </div>
        <div style={{ width: "100%", display: "flex", gap: "60px", flexDirection: "row" }}>
          <div>
            <FormattedMessage id={"preCog.assetsTab.drawer.min"} values={{percentage: depreciationAssetRates?.reduced ? `${numeral(depreciationAssetRates?.reduced).format("0,0.[00]")}%` : "-%"}} />
          </div>
          <div>
            <FormattedMessage id={"preCog.assetsTab.drawer.anticipate"}  values={{percentage: depreciationAssetRates?.accelerated ? `${numeral(depreciationAssetRates?.accelerated).format("0,0.[00]")}%` : "-%"}}/>
          </div>
        </div>
      </VaporAccordion>

      <VaporAccordion 
        title={<FormattedMessage id={"preCog.assetsTab.drawer.statutoryDepreciationType"} />}
        autoOpenInit={true}
        autoOpen={true}
      >
        <Radio.Group
          value={editable["statutoryDepreciationType"]}
          style={{ display: "flex", flexWrap: "wrap"}}
          onChange={e => {            
            /** halfFirstYear always true if statutoryDepreciationType is TAX_CRITERIA */
            setEditable({ ...editable, 
              "statutoryDepreciationType": e.target.value, 
              // "statutoryDepreciationValue": e.target.value==="TAX_CRITERIA" ? "" : editable["statutoryDepreciationValue"], 
              "halfFirstYear": e.target.value==="TAX_CRITERIA" ? true : false });
            setModifiedFields({ ...modifiedFields, 
              "statutoryDepreciationType": e.target.value, 
              "statutoryDepreciationValue": e.target.value==="TAX_CRITERIA" ? "" : editable["statutoryDepreciationValue"],
              "halfFirstYear": e.target.value==="TAX_CRITERIA" ? true : false });
          }}
        >
          <div style={{width: "45%"}}>
            <Radio className="pre-cog-assets-radio" value={"TAX_CRITERIA"}>
              <FormattedMessage id={"preCog.assetsTab.drawer.TAX_CRITERIA"} />
            </Radio>
          </div>

          {/* https://jira.teamsystem.com/browse/DOP-1017
          
          <div style={{width: "45%"}}>
            <Radio className="pre-cog-assets-radio" value={"DESC_METHOD"}>
              <FormattedMessage id={"preCog.assetsTab.drawer.DESC_METHOD"} />
            </Radio>
            <div style={{ display: editable["statutoryDepreciationType"] === "DESC_METHOD" ? "block" : "none" }}
            >
              <div className="precog-withholding-drawer-form—label-text" style={{ display: "flex", alignItems: "center", fontSize: "14px", margin: "10px 0" }}>
                <FormattedMessage id={"preCog.assetsTab.drawer.civilDepreciationValue_desc_method"} />
              </div>
              <InputNumber
                className="precog-withholding-drawer-inputCustom hide-arrow "
                value={editable["statutoryDepreciationValue"]}
                disabled={readOnly}
                onChange={e => {
                  editable["statutoryDepreciationValue"] = e;
                }}
                controls={false}
                bordered={false}
                onBlur={() => setModifiedFields({ ...modifiedFields, "statutoryDepreciationValue": editable["statutoryDepreciationValue"] })}
              />
            </div>
          </div>
          */}

          {/* https://jira.teamsystem.com/browse/DOP-1017
          <div style={{width: "45%" , marginTop: "20px"}}>
            <Radio className="pre-cog-assets-radio" value={"PERIOD"}>
              <FormattedMessage id={"preCog.assetsTab.drawer.PERIOD"} />
            </Radio>
            <div style={{ display: editable["statutoryDepreciationType"] === "PERIOD" ? "block" : "none" }}
            >
              <div className="precog-withholding-drawer-form—label-text" style={{ display: "flex", alignItems: "center", fontSize: "14px", margin: "10px 0" }}>
                <FormattedMessage id={"preCog.assetsTab.drawer.DATA_END_PERIOD"} />
              </div>                          
              <VaporDatePicker
                disabled={readOnly}
                value={editable["statutoryDepreciationValue"] ? moment(editable["statutoryDepreciationValue"]) : undefined}
                onBlur={() => setModifiedFields({ ...modifiedFields, "statutoryDepreciationValue": editable["statutoryDepreciationValue"].format("YYYY-MM-DD") })}
                onChange={e => {
                  setEditable({ ...editable, "statutoryDepreciationValue": e });
                  setModifiedFields({ ...modifiedFields, "statutoryDepreciationValue": e.format("YYYY-MM-DD") });
                }}
                getPopupContainer={(trigger) => trigger.parentNode}
              />
            </div>
          </div>
          */}
          <div style={{width: "45%"}}>
            <Radio className="pre-cog-assets-radio" value={"FIXED_PERCENTAGE"}>
              <FormattedMessage id={"preCog.assetsTab.drawer.FIXED_PERCENTAGE"} />
            </Radio>
            <div style={{ display: editable["statutoryDepreciationType"] === "FIXED_PERCENTAGE" ? "block" : "none" }}
            >
              <div className="precog-withholding-drawer-form—label-text" style={{ display: "flex", alignItems: "center", fontSize: "14px", margin: "10px 0"  }}>
                <FormattedMessage id={"preCog.assetsTab.drawer.fillPercentage"} />
              </div>
              <NumberFormat
                displayType={"number"}
                allowEmptyFormatting={false}
                allowLeadingZeros={true}
                thousandSeparator={"."}
                decimalSeparator={","}              
                className="inputCustom drawer-inputCustom"
                allowNegative={false}
                placeholder="-"
                suffix={"%"}
                disabled={readOnly}
                isNumericString={editable["statutoryDepreciationValue"] ? true : false}
                value={editable["statutoryDepreciationValue"] ?  numeral(parseFloat(editable["statutoryDepreciationValue"])).format("0,0.00") : null}
                onValueChange={(el) => {                
                  setEditable({ ...editable, "statutoryDepreciationValue": el.floatValue > 100 ? 100 : el.floatValue });                 
                }                
                }    
                onBlur={() => {
                  if (editable.statutoryDepreciationValue) {
                    setModifiedFields({ ...modifiedFields, "statutoryDepreciationValue": editable.statutoryDepreciationValue});
                  } else {
                    setFieldsToDelete(["statutoryDepreciationValue"]);
                  }
                }}                                
              />             
            </div>
          </div>

        </Radio.Group>
        
      </VaporAccordion>

      <div 
        style={{display: editable["isIrapPercentVisible"] /* ["IRPEF_OPTION_IRAP", "IRES"].includes(editable["taxationType"])*/ ? "block" : "none"}}
      >
        <VaporAccordion 
          title={<FormattedMessage id={"preCog.assetsTab.drawer.irapAmortization"} />}
          autoOpenInit={true}
          autoOpen={true}
        >
        
          <div className="precog-withholding-drawer-form—label-text" style={{ display: "flex", alignItems: "center" }}>
            <FormattedMessage id={"preCog.assetsTab.drawer.irapPercent"} />
          </div>
          <NumberFormat
            displayType={"number"}
            allowEmptyFormatting={false}
            allowLeadingZeros={true}
            thousandSeparator={"."}
            decimalSeparator={","}              
            className="inputCustom drawer-inputCustom "
            placeholder="-"
            suffix={"%"}
            disabled={ editable["isIrapPercentEditable"]}
            style={{width: "200px"}}
            //  value={editable["irapPercent"]}
            isNumericString={editable["statutoryDepreciationValue"] ? true : false}
            value={editable["irapPercent"] ?  numeral(parseFloat(editable["irapPercent"])).format("0,0.00") : null}
            onValueChange={(el) => {                
              setEditable({ ...editable, "irapPercent": el.floatValue > 100 ? 100 : el.floatValue });             
            }}    
            onBlur={() => {
              if (editable.irapPercent) {
                setModifiedFields({ ...modifiedFields, "irapPercent": editable.irapPercent});
              } else {
                setFieldsToDelete(["irapPercent"]);
              }
            }}                                
          />
        </VaporAccordion>
      </div>

      <VaporAccordion 
        title={<FormattedMessage id={"preCog.assetsTab.drawer.otherDepreciationCriteria"} />}
        autoOpenInit={true}
        autoOpen={true}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "5px", flexWrap: "wrap" }}>
          <Toggle
            disabled={readOnly}
            onChange={value => {
              setEditable({ ...editable, "sellingDepreciation": value });
              setModifiedFields({ ...modifiedFields, "sellingDepreciation": value });
            }}
            checked={editable["sellingDepreciation"]}
          />
          <div className="precog-withholding-drawer-form—label-text" style={{ marginBottom: 0 }}>
            <FormattedMessage id={"preCog.assetsTab.drawer.sellingDepreciation"} />
          </div>
          <FontAwesomeIcon
            icon={["fas", "info-circle"]}
            style={{
              color: "#0090d1",
              cursor: "pointer",
              fontSize: "15px",
              marginLeft: "10px",
              marginRight: "35px"
            }}
          />

          <Toggle
            disabled={readOnly || editable["statutoryDepreciationType"] === "TAX_CRITERIA"}
            onChange={value => {
              setEditable({ ...editable, "halfFirstYear": value });
              setModifiedFields({ ...modifiedFields, "halfFirstYear": value });
            }}
            checked={editable["halfFirstYear"]}
          />
          <div className="precog-withholding-drawer-form—label-text" style={{ marginBottom: 0, marginRight: "25px" }}>
            <FormattedMessage id={"preCog.assetsTab.drawer.halfFirstYear"} />
          </div>
          {editable.materialGood === false && (<>
            <Toggle
              disabled={readOnly}
              onChange={value => {
                setEditable({...editable, "reportInDays": value});
                setModifiedFields({...modifiedFields, "reportInDays": value});
              }}
              checked={editable["reportInDays"]}
            />
            <div className="precog-withholding-drawer-form—label-text" style={{ marginBottom: 0 }}>
              <FormattedMessage id={"preCog.assetsTab.drawer.reportInDays"} />
            </div>
            <Tooltip 
              title={
                <FormattedMessage 
                  id={"preCog.assetsTab.tooltips.reportDays"} />} 
              color={"rgb(0, 80, 117)"}>
              <FontAwesomeIcon
                icon={["fas", "info-circle"]}
                style={{
                  color: "#0090d1",
                  cursor: "pointer",
                  fontSize: "15px",
                  marginLeft: "10px",
                  marginRight: "35px"
                }}
              />
            </Tooltip>
          </>)}
        </div>
      </VaporAccordion>

      <VaporAccordion 
        title={<FormattedMessage id={"preCog.assetsTab.drawer.taxRelief"} />}
        autoOpenInit={true}
        autoOpen={true}
      >
        <div style={{display: "flex", justifyContent: "space-between"}}>
          <div style={{ width: "30%" }}>
            <div className="precog-withholding-drawer-form—label-text">
              <FormattedMessage id={"preCog.assetsTab.drawer.taxRelief"} />
            </div>
            <Select
              className="pre-cog-assets-drawer-select"
              style={{ width: "100%" }}
              showSearch
              allowClear
              placeholder={`seleziona ${intl.formatMessage({
                id: "preCog.assetsTab.drawer.taxReliefType"
              })}`}
              optionFilterProp="children"
              getPopupContainer={trigger => trigger.parentNode}
              value={editable["taxRelief"]}
              filterOption={(input, option) => 
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              onClear={() => {
                setEditable({ ...editable, "taxRelief": undefined, "taxReliefType": undefined, "taxReliefDate": null });
                setFieldsToDelete(["taxRelief", "taxReliefType", "taxReliefDate"]);
              }}
              onSelect={value => {
                setEditable({ ...editable, "taxRelief": value, "taxReliefType": undefined, "taxReliefDate": null  });
                setModifiedFields({ ...modifiedFields, "taxRelief": value });
                setFieldsToDelete(["taxReliefType", "taxReliefDate"]);
              }}
            >
              {taxReliefOptions.map((el, index) => {
                if (!el.condition || (el.conditionValue && el.conditionValue === editable[el.condition]) || (el.conditionValues && el.conditionValues.includes(editable[el.condition])))
                  return <Select.Option key={index} value={el.value}>{intl.formatMessage({
                    id: `preCog.assetsTab.drawer.${el.id}`
                  }) }</Select.Option>;
                return null;
              })}
            </Select>
          </div>
          <div style={{ width: "30%" }}>
            <div className="precog-withholding-drawer-form—label-text">
              <FormattedMessage id={"preCog.assetsTab.drawer.taxReliefType"} />
            </div>
            <Select
              className="pre-cog-assets-drawer-select"
              style={{ width: "100%" }}
              showSearch
              allowClear
              optionFilterProp="children"
              placeholder={`seleziona ${intl.formatMessage({
                id: "preCog.assetsTab.drawer.taxReliefType"
              })}`}
              getPopupContainer={trigger => trigger.parentNode}
              value={editable["taxReliefType"]}
              filterOption={(input, option) => 
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              onClear={() => {
                setEditable({ ...editable, "taxReliefType": undefined });
                setFieldsToDelete(["taxReliefType"]);
              }}
              onSelect={value => {
                setEditable({ ...editable, "taxReliefType": value });
                setModifiedFields({ ...modifiedFields, "taxReliefType": value });
              }}
            >              
              {taxReliefTypeOptions.map((el, index) => {
                if (!el.condition || (el.conditionValue && el.conditionValue === editable[el.condition]) || (el.conditionValues && el.conditionValues.includes(editable[el.condition])))
                  return <Select.Option key={index} value={el.value}>{intl.formatMessage({
                    id: `preCog.assetsTab.drawer.${el.id}`
                  }) }</Select.Option>;
                return null;
              })}
            </Select>
          </div>
          <div style={{ width: "30%" }}> 
            <div className="precog-withholding-drawer-form—label-text">
              <FormattedMessage id={"preCog.assetsTab.drawer.taxReliefDate"} />
            </div>
            <VaporDatePicker
              disabled={readOnly}
              allowClear
              value={editable["taxReliefDate"] ? moment(editable["taxReliefDate"]) : undefined}
              onBlur={() => setModifiedFields({ ...modifiedFields, "taxReliefDate": editable["taxReliefDate"].format("YYYY-MM-DD") })}
              onChange={e => {
                setEditable({ ...editable, "taxReliefDate": e });
                if (e) {
                  setModifiedFields({ ...modifiedFields, "taxReliefDate": e.format("YYYY-MM-DD") });
                } else {
                  setFieldsToDelete(["taxReliefDate"]);
                }
              }}
              format={dateFormatList}
              style={{width:"100%"}}
              getPopupContainer={(trigger) => trigger.parentNode}
            />
          </div>
        </div>
      </VaporAccordion>
    </div>
  );
};

export default DepreciationDrawerFields;
